module.exports = __webpack_public_path__ + "static/media/Logo_Premier.14704155.png";